module.exports = __webpack_public_path__ + "img/login-btn-new.5da2c46.png";